import React from 'react';
import PropTypes from 'prop-types';
import PartialTable from 'components/partials/PartialTable';

const SkillLevelTable = ({
  data,
  paging,
  total,
  nextPage,
  previousPage,
  gotoPage,
  handleClickRow,
  onPageSizeChange
}) => {
  const columns = [
    {
      accessor: 'id',
      Header: 'ID',
      isVisible: false
    },
    {
      accessor: 'skillName',
      Header: 'Name'
    },{
      accessor: 'areaName',
      Header: 'Area Name',
    },
    {
      accessor: 'levelName',
      Header: 'Level Name',
    },
    {
      accessor: 'activityName',
      Header: 'Activity Name',
    },
    {
      accessor: 'position',
      Header: 'Position',
    }
  ];

  return (
    <>
      <PartialTable
        data={data}
        columns={columns}
        paging={paging}
        total={total}
        nextPage={nextPage}
        previousPage={previousPage}
        gotoPage={gotoPage}
        onPageSizeChange={onPageSizeChange}
        handleClickRow={handleClickRow}
        textAlign=""
      />
    </>
  );
};

SkillLevelTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  paging: PropTypes.object,
  total: PropTypes.number,
  nextPage: PropTypes.func,
  previousPage: PropTypes.func,
  gotoPage: PropTypes.func,
  onPageSizeChange: PropTypes.func,
  handleClickRow: PropTypes.func,
};

export default SkillLevelTable;
